import { makeAutoObservable, runInAction } from 'mobx'

class CookiesPopupStore {
  isVisible = false

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true })
  }

  async init() {
    const { getCookie } = await import('@/utils/cookies')

    const cookieIsAccept = getCookie('cookieIsAccept') === 'true'

    if (!cookieIsAccept) {
      runInAction(() => {
        this.isVisible = true
      })
    }
  }

  async hidePopup() {
    const { setCookie } = await import('@/utils/cookies')

    runInAction(() => {
      this.isVisible = false
    })

    setCookie('cookieIsAccept', 'true', 7)
  }
}

export const cookiesPopupStore = new CookiesPopupStore()
